import QrCoreForm from '../../components/features/qr/QrCoreForm'

const CreateQRPage = () => {
  return (
    <QrCoreForm />
  )
}

export default CreateQRPage